import * as React from "react";
import { OutletContextProps } from "../../helpers/RouterHelper";
import enhanceSectionsPage from "../../hocs/enhanceSectionsPage";
import { useFetchStudyRecordComments } from "../../hooks/http/useFetchStudyRecordComments";
import { useQueryError } from "../../hooks/http/useQueryError";
import { useOnMainScrollAreaScroll } from "../../hooks/useMainScrollAreaScroll";
import SectionInterface from "../../interfaces/SectionInterface";
import SectionStudyRecordComments from "./SectionStudyRecordComments";

interface Props extends OutletContextProps {
  section: SectionInterface;
}

const SectionStudyRecordCommentsPage = ({ section, setActiveMenu }: Props) => {
  React.useEffect(() => {
    setActiveMenu("");
  }, [setActiveMenu]);

  const { allComments, loadMore, error, isFetching } =
    useFetchStudyRecordComments({
      sectionId: section.id,
    });
  useQueryError(error);

  // Handle infinite scroll
  useOnMainScrollAreaScroll(loadMore, [loadMore]);

  return (
    <SectionStudyRecordComments
      allComments={allComments ?? []}
      loading={isFetching}
    />
  );
};

const pageInfo = {
  title: "お知らせ一覧",
};

export default enhanceSectionsPage(SectionStudyRecordCommentsPage, pageInfo);
